exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vanilla-slider {\n  position: relative;\n  text-align: left;\n  user-select: none; }\n  .vanilla-slider__handle {\n    position: absolute;\n    z-index: 2;\n    display: block;\n    white-space: nowrap;\n    cursor: default; }\n    .vanilla-slider__handle_last-type {\n      z-index: 3; }\n    .vanilla-slider__handle_active {\n      z-index: 4; }\n    .vanilla-slider__handle_fixed {\n      z-index: 1; }\n  .vanilla-slider_horizontal {\n    width: 100%; }\n    .vanilla-slider_horizontal .vanilla-slider__handle {\n      top: -0.35em;\n      margin-left: -0.55em; }\n  .vanilla-slider_vertical {\n    height: 100%; }\n    .vanilla-slider_vertical .vanilla-slider__handle {\n      left: -0.35em;\n      margin-bottom: -0.7em; }\n  .vanilla-slider__range {\n    position: absolute;\n    z-index: 1;\n    display: block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?importLoaders=2!../node_modules/sass-loader/lib/loader.js!./components/view/view.scss
// module id = ../node_modules/css-loader/index.js?importLoaders=2!../node_modules/sass-loader/lib/loader.js!./components/view/view.scss
// module chunks = 0